import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { InvoiceModel } from '../models/entry-summaries';
import { enumOcrStatus } from '@data-layer/enums/common';

@Injectable({
  providedIn: 'root',
})
export class InvoicesRepository {
  constructor(private apiService: ApiService) {}

  public get(invoiceId: number): Observable<InvoiceModel> {
    return this.apiService.get<InvoiceModel>(`${environment.url.prefixCustoms}v2/invoices/${invoiceId}`);
  }

  public update(invoiceId: number, invoice: Partial<InvoiceModel>): Observable<InvoiceModel> {
    return this.apiService.put<InvoiceModel>(`${environment.url.prefixCustoms}v2/invoices/${invoiceId}`, invoice);
  }

  public delete(invoiceId: number): Observable<never> {
    return this.apiService.delete(`${environment.url.prefixCustoms}v2/invoices/${invoiceId}`);
  }

  public create(shipmentId: number, invoice: Partial<InvoiceModel>): Observable<InvoiceModel> {
    return this.apiService.post<InvoiceModel>(`${environment.url.prefixCustoms}v2/shipments/${shipmentId}/invoices`, invoice);
  }

  public runDocumentRecognition(invoiceId: number, runDocumentRecognition: boolean, isShowLoader: boolean = false): Observable<never> {
    return this.apiService.put(
      `${environment.url.prefixCustoms}v2/invoices/${invoiceId}/run-document-recognition`,
      runDocumentRecognition,
      null,
      { isShowLoader },
    );
  }

  public getOcrStatus(invoiceId: number, isShowLoader: boolean = false): Observable<enumOcrStatus> {
    return this.apiService.get(`${environment.url.prefixCustoms}v2/invoices/${invoiceId}/ocr-status`, null, { isShowLoader });
  }

  public setOcrStatus(invoiceId: number, isShowLoader: boolean = false): Observable<never> {
    return this.apiService.put(`${environment.url.prefixCustoms}v2/invoices/${invoiceId}/ocr-status`, null, null, { isShowLoader });
  }
}
